export default __webpack_public_path__ + "static/media/arrow-down-s-line1.0970141f.svg";